import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTenantNavigation } from "../../hooks/useTenantNavigation";

const RefreshRedirect = () => {
  const navigate = useTenantNavigation();
  const { idTransaccionEditarCompra, idEstado } = useParams();
  

  useEffect(() => {
    // Al montarse, redirige inmediatamente a la ruta del componente, usando los parámetros
    navigate(`editarCompraComponent/${idTransaccionEditarCompra}/${idEstado}`);
  }, [idTransaccionEditarCompra, idEstado, navigate]);

  // Opcional: podés retornar un indicador visual mientras se ejecuta la redirección
  return <p>Actualizando datos...</p>;
};

export default RefreshRedirect;
